module.exports = __webpack_public_path__ + "assets/img/00098.fbea6f84.png";